import { useVisibleContainer } from "../hooks/useVisibleContainer";

// Route-effect component for "/music" - the new dedicated Music page.
// Renders nothing; MusicPanel.tsx (mounted unconditionally in AppRoot)
// portals its actual content into #musicView, which this only shows/hides.
export function MusicRouteScreen() {
  useVisibleContainer("musicView");
  return null;
}
